exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2gsBp9jNIPaDnKJ2ocW0mz {\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 40.22px;\n    letter-spacing: -0.37px;\n    color: #666666;\n}", ""]);

// exports
exports.locals = {
	"root": "_2gsBp9jNIPaDnKJ2ocW0mz"
};